import { sortBy } from 'lodash-es'
export { compact, countBy, last, sample, sampleSize, shuffle, xor } from 'lodash-es'

export { sortBy }

// Public: Sorts the array so that the items that match the predicate are first.
export function sortByCondition<T> (array: T[], predicate: (item: T) => any) {
  return sortBy(array, item => !predicate(item))
}

export function listToSentence (arr: string[], useAmpersand = false) {
  const connector = useAmpersand ? ' & ' : ' and '

  if (!Array.isArray(arr)) return ''
  const len = arr.length

  if (len === 0) return ''
  if (len === 1) return arr[0]
  if (len === 2) return arr.join(connector)

  return `${arr.slice(0, -1).join(', ')}${connector}${arr[len - 1]}`
}
